import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const routes = [
  {
    path: '/',
    redirect: '/home',
    meta: { hide: true },
  },
  {
    path: '/home',
    name: 'home',
    meta: { hide: true, path: 'home' },
    component: () => import('../views/home'),
  },
  {
    path: '/terms',
    name: 'Terms & Conditions',
    meta: { hide: false, path: 'terms' },

    component: () => import('../views/terms'),
  },
  {
    path: '/refund',
    name: 'Refund Policy',
    meta: { hide: false, path: 'refund' },
    component: () => import('../views/refund'),
  },
  {
    path: '/privacy',
    name: 'Privacy Policy',
    meta: { hide: false, path: 'privacy' },
    component: () => import('../views/privacy'),
  },
  {
    path: '/about',
    name: 'About Us',
    meta: { hide: false, path: 'about' },
    component: () => import('../views/about'),
  },
  {
    path: '/faq',
    name: 'FAQ',
    meta: { hide: false, path: 'faq' },
    component: () => import('../views/faq'),
  },
]

export default new Router({
  mode: "hash",
  linkActiveClass: "linkActive",
  routes,
})



// WEBPACK FOOTER //
// ./src/router/index.js